import { render, staticRenderFns } from "./InvitationToBuildProfile.vue?vue&type=template&id=6d6a2cbe&scoped=true"
import script from "./InvitationToBuildProfile.vue?vue&type=script&lang=js"
export * from "./InvitationToBuildProfile.vue?vue&type=script&lang=js"
import style0 from "./InvitationToBuildProfile.vue?vue&type=style&index=0&id=6d6a2cbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6a2cbe",
  null
  
)

export default component.exports